<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style=" margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :supervisores="enableSupervisor"
          :receitas="enableReceita"
          :url="link"
        />
        <v-responsive>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="5"
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="3"
                    lg="12"
                    class="text-left"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'361'"
                      :text="'Faturamento'"
                      :texto-information="textoFaturamento"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="valorFaturamento"
                      :padding="dynamicPaddingBloco1"
                      :loading="loadingFaturamento"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'352'"
                      :text="'Peso Faturado (KG)'"
                      :texto-information="textoPesoFaturado"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="valorPesoFaturado"
                      :padding="dynamicPaddingDadosAtual"
                      :loading="loadingPesoFaturado"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'353'"
                      :text="'Preço Médio (Fat. / KG)'"
                      :texto-information="textoPrecoMedio"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="valorPrecoMedio"
                      :padding="dynamicPaddingDadosAtual"
                      :loading="loadingPrecoMedio"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'342'"
                      :text="'Devolução'"
                      :texto-information="textoDevolucao"
                      :style-object="styleObjectDevolucao"
                      :componente-valor="true"
                      :valor="valorDevolucao"
                      :padding="dynamicPaddingDadosAtual"
                      :loading="loadingDevolucao"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'101'"
                      :text="'Meta'"
                      :texto-information="textoMeta"
                      :style-object="styleObjectMeta"
                      :componente-valor="true"
                      :valor="valorMeta"
                      :padding="dynamicPaddingDadosAtual"
                      :loading="loadingMeta"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="7"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Comparativo Fat. x Meta
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip top>
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationFatxMetaComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('103')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="codigo === '103'"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <bar-line-chart
                          id="BarLineComercial4"
                          class="itemBarrasLinhasComercial4"
                        />
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container><br>
          <v-divider
            id="dividerBloco1Comercial4"
            class="mb-5"
          />
          <v-row>
            <v-col
              id="blocoMesAnteriorIdComercial4"
              cols="12"
              sm="12"
              md="12"
              lg="5"
            >
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <h3 class="text-center">
                      Mês Anterior
                    </h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    id="faturamentoAnteriorIdComercial4"
                    cols="12"
                    sm="12"
                    md="6"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'362'"
                      :text="'Faturamento'"
                      :texto-information="textoFaturamentoAnterior"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="valorFaturamentoAnterior"
                      :padding="dynamicPaddingBloco2"
                      :loading="loadingFaturamentoAnterior"
                    />
                  </v-col>
                  <v-col
                    id="textoDevolucaoAnteriorIdComercial4"
                    cols="12"
                    sm="12"
                    md="6"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'343'"
                      :text="'Devolução'"
                      :texto-information="textoDevolucaoAnterior"
                      :style-object="styleObjectDevolucao"
                      :componente-valor="true"
                      :valor="valorDevolucaoAnterior"
                      :padding="dynamicPaddingBloco2"
                      :loading="loadingDevolucaoAnterior"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <v-row>
                      <v-col
                        id="componentePesoFatAnterior"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <dashoard-card-view
                          :exibir-texto-titulo="true"
                          :code-information="'354'"
                          :text="'Peso Faturado (KG)'"
                          :texto-information="textoPesoFatAnterior"
                          :style-object="styleObject"
                          :componente-valor="true"
                          :valor="valorPesoFaturadoAnterior"
                          :padding="dynamicPaddingBloco2"
                          :loading="loadingPesoFaturadoAnterior"
                        />
                      </v-col>
                      <v-col
                        id="componentePrecoMedioAnterior"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <dashoard-card-view
                          :exibir-texto-titulo="true"
                          :code-information="'355'"
                          :text="'Preço Médio (Fat. / KG)'"
                          :texto-information="textoPrecoMedioAnterior"
                          :style-object="styleObject"
                          :componente-valor="true"
                          :valor="valorPrecoMedioAnterior"
                          :padding="dynamicPaddingBloco2"
                          :loading="loadingPrecoMedioAnterior"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col
              id="linhaVerticalComercial4"
              cols="12"
              sm="12"
              md="12"
              lg="2"
            >
              <v-divider vertical />
            </v-col>
            <v-col
              id="componenteDadosAnoAnteriorComercial4"
              cols="12"
              sm="12"
              md="12"
              lg="5"
            >
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <h3 class="text-center">
                      Mês do Ano Anterior
                    </h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    id="compFatMesAnoAnteriorComercial4"
                    cols="12"
                    sm="12"
                    md="6"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'363'"
                      :text="'Faturamento'"
                      :texto-information="textoFaturamentoAnoAnterior"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="valorFaturamentoAnoAnterior"
                      :padding="dynamicPaddingBloco3"
                      :loading="loadingFaturamentoAnoAnterior"
                    />
                  </v-col>
                  <v-col
                    id="componenteDevoluaAnoAnterior"
                    cols="12"
                    sm="12"
                    md="6"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'344'"
                      :text="'Devolução'"
                      :texto-information="textoDevolucaoAnoAnterior"
                      :style-object="styleObjectDevolucao"
                      :componente-valor="true"
                      :valor="valorDevolucaoAnoAnterior"
                      :padding="dynamicPaddingBloco3"
                      :loading="loadingDevolucaoAnoAnterior"
                    />
                  </v-col>
                  <v-col
                    id="componentePesoFaturadoAnoAnterior"
                    cols="12"
                    sm="12"
                    md="6"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'356'"
                      :text="'Peso Faturado (KG)'"
                      :texto-information="textoPesoFatAnoAnterior"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="valorPesoFaturadoAnoAnterior"
                      :padding="dynamicPaddingBloco3"
                      :loading="loadingPesoFaturadoAnoAnterior"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="6"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'357'"
                      :text="'Preço Médio (Fat. / KG)'"
                      :texto-information="textoPrecoMedioAnoAnterior"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="valorPrecoMedioAnoAnterior"
                      :padding="dynamicPaddingBloco3"
                      :loading="loadingPrecoMedioAnoAnterior"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <v-divider
            id="dividerBloco1Comercial4"
            class="mb-5 divider2"
          />
          <v-row>
            <v-col
              id="valorMonetarioIdComercial4"
              cols="12"
              sm="12"
              md="12"
              lg="4"
            >
              <v-container>
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        E quanto falta para atingirmos?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip top>
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('108')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="codigo === '108'"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <valor-monetario id="valorMonetarioGraficoComercial4" />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                      >
                        <valor-monetario-diario id="valorMonetarioDiarioGraficoComercial4" />
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="4"
            >
              <v-container>
                <v-row>
                  <v-col
                    id="componenteTendenciaFaturamento"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'109'"
                      :text="'Qual a tendência de faturamento?'"
                      :texto-information="textoTendencia"
                      :style-object="styleObject"
                      :componente-valor="true"
                      :valor="valorTedenciaFaturamento"
                      :padding="dynamicPaddingBloco4"
                      :loading="loadingTendenciaFaturamento"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'110'"
                      :text="'Qual a quantidade de dias úteis no mês?'"
                      :texto-information="textoDiasUteis"
                      :style-object="styleObject"
                      :componente-dias-uteis="true"
                      :dias-uteis="diasUteis"
                      :dias-pecorrido="diasPecorrido"
                      :padding="dynamicPaddingBloco4"
                      :loading="loadingDiasUteis"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col
              id="componenteCarteiraPedidosComercial4"
              cols="12"
              sm="12"
              md="12"
              lg="4"
            >
              <v-container>
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        E minha carteira de pedidos?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip top>
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('358')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="codigo === '358'"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <show-carteira-pedidos id="componentePedidos" />
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-col>
          </v-row>
        </v-responsive>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import Comercial from '../../../../services/comercial'
  import Comercial4 from '../../../../services/comercial4'

  export default {
    name: 'PageComercial',
    emits: ['updateDatas', 'setDados', 'setOrientacao', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
      BarLineChart: () => import('../../graficos/Comercial/GraficoFatMetaMedia'),
      ValorMonetario: () => import('../../graficos/Comercial/ValorMonetarioPersonalizado'),
      ValorMonetarioDiario: () => import('../../graficos/Comercial/ValorMonetarioDiarioPersonalizado'),
      ShowCarteiraPedidos: () => import('../../components/comercial/gestaoComercial/CarteiraPedidosPersonalizadoComercial'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      styleObjectError: {
        color: localStorage.corError,
      },
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      styleObjectCarteiraPedidos: {
        color: '#9d9ac5',
      },
      styleObjectDevolucao: {
        color: '#C62828',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      empresa: [],
      supervisores: [],
      receitas: [],
      vendedor: [],
      rede: [],
      categoria: [],
      promotor: [],
      codigo: 0,
      textoFaturamento: '',
      textoMeta: '',
      textoMetaMensal: '',
      textoFaturamentoMeta: '',
      textoFaturamentoAnterior: '',
      textoFatxFatAnterior: '',
      textoFaturamentoAnoAnterior: '',
      textoFatxFatAnoAnterior: '',
      textoAtigimento: '',
      textoTendencia: '',
      textoDiasUteis: '',
      textoPedidos: '',
      textoVolume: '',
      textoDevolucao: '',
      textoDevolucaoAnterior: '',
      textoDevolucaoAnoAnterior: '',
      textoPrecoMedio: '',
      textoPesoFaturado: '',
      textoPrecoMedioAnterior: '',
      textoPesoFatAnterior: '',
      textoPesoFatAnoAnterior: '',
      textoPrecoMedioAnoAnterior: '',
      orientacao: [],
      codigoIds: ['101', '102', '103', '105', '107', '108', '109', '110', '111', '112', '342', '343', '344', '352', '353', '354', '355', '356', '357', '358', '361', '362', '363'],
      permissaoGestaoComercial: '',
      activeHover: false,
      paginaEnable: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisor: true,
      enableReceita: true,
      devolucaoImpropria: 0,
      porcentagemImpropria: 0,
      devImpropriaEnable: false,
      link: window.location.href,
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPesoFaturado: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPrecoMedio: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorMeta: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFaturamentoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPesoFaturadoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPrecoMedioAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFaturamentoAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPesoFaturadoAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPrecoMedioAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorTedenciaFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      diasUteis: '0',
      diasPecorrido: '0',
      dynamicPaddingBloco1: '',
      dynamicPaddingBloco2: '',
      dynamicPaddingBloco3: '',
      dynamicPaddingBloco4: '',
      dynamicPaddingValorPedido: '',
      dynamicPaddingValorMonetario: '',
      dynamicPaddingDadosAtual: '',
      dynamicPaddingFatxMeta: '',
      loadingFaturamento: false,
      loadingPesoFaturado: false,
      loadingPrecoMedio: false,
      loadingDevolucao: false,
      loadingMeta: false,
      loadingFaturamentoAnterior: false,
      loadingDevolucaoAnterior: false,
      loadingPesoFaturadoAnterior: false,
      loadingPrecoMedioAnterior: false,
      loadingFaturamentoAnoAnterior: false,
      loadingDevolucaoAnoAnterior: false,
      loadingPesoFaturadoAnoAnterior: false,
      loadingPrecoMedioAnoAnterior: false,
      loadingTendenciaFaturamento: false,
      loadingDiasUteis: false,
      textoOrientacao: '',
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Gestão Comercial')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 37.5rem !important'

          this.dynamicPaddingDadosAtual = 'padding-right: 11rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 56rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 11rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 11rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 19rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 1rem !important'

          this.dynamicPaddingValorPedido = 'padding-right: 1rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 28rem !important'

          this.dynamicPaddingDadosAtual = 'padding-right: 6rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 44rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 6rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 6rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 12rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 6rem !important'

          this.dynamicPaddingValorPedido = 'padding-right: 7.6rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingBloco1 = 'padding-right: 11rem !important'

          this.dynamicPaddingDadosAtual = 'padding-right: 11rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 8rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 11rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 11rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 8rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 1rem !important'

          this.dynamicPaddingValorPedido = 'padding-right: 1rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingBloco1 = 'padding-right: 25rem !important'

          this.dynamicPaddingDadosAtual = 'padding-right: 25rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 25rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 25rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 25rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 25rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 25rem!important'

          this.dynamicPaddingValorPedido = 'padding-right: 10rem !important'
        } else {
          this.dynamicPaddingBloco1 = 'padding-right: 20.2rem !important'

          this.dynamicPaddingDadosAtual = 'padding-right: 2rem !important'

          this.dynamicPaddingFatxMeta = 'padding-right: 31rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 2rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 2rem !important'

          this.dynamicPaddingBloco4 = 'padding-right: 6rem !important'

          this.dynamicPaddingValorMonetario = 'padding-right: 0rem !important'

          this.dynamicPaddingValorPedido = 'padding-right: 1rem !important'
        }
      },

      orientacaoEnvio () {
        eventEmit.$emit('set-orientacao', this.orientacao)
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receitas, segmento, classificacao, produto, cidade, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisores = supervisores
        this.receitas = receitas
        this.vendedor = vendedores
        this.rede = redes
        this.categoria = categoria
        this.promotor = promotor

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', primeiroDia)
        localStorage.setItem('dataFinal', dataFinal)

        this.updateDate()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async updateDate () {
        eventEmit.$emit('update-datas', this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, this.vendedor, this.rede, this.categoria, this.promotor)

        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPesoFaturado = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
        this.valorPrecoMedio = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDevolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorMeta = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDevolucaoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.title = false
        this.valorPesoFaturadoAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
        this.valorPrecoMedioAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDevolucaoAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPesoFaturadoAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
        this.valorPrecoMedioAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorTedenciaFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.diasUteis = '0'
        this.diasPecorrido = '0'

        this.loadingFaturamento = true
        this.loadingPesoFaturado = true
        this.loadingPrecoMedio = true
        this.loadingDevolucao = true
        this.loadingMeta = true
        this.loadingFaturamentoAnterior = true
        this.loadingDevolucaoAnterior = true
        this.loadingPesoFaturadoAnterior = true
        this.loadingPrecoMedioAnterior = true
        this.loadingFaturamentoAnoAnterior = true
        this.loadingDevolucaoAnoAnterior = true
        this.loadingPesoFaturadoAnoAnterior = true
        this.loadingPrecoMedioAnoAnterior = true
        this.loadingTendenciaFaturamento = true
        this.loadingDiasUteis = true

        await Comercial.showFaturamento(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamento = false })

        await Comercial4.showPesoFaturado(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorPesoFaturado = resposta.data.kilos.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })

            this.valorPrecoMedio = resposta.data.precoMedio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => {
          this.loadingPesoFaturado = false

          this.loadingPrecoMedio = false
        })

        await Comercial.showDevolucao(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolucao = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDevolucao = false })

        await Comercial.showMeta(this.primeiroDia, this.date, this.select, this.supervisores, localStorage.tokencontrato, []).then(resposta => {
          if (resposta.data.status) {
            this.valorMeta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.valorMeta = resposta.data.valorMeta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, 'Não há meta no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingMeta = false })

        await Comercial.showFaturamentoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoAnterior = resposta.data.faturamentoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamentoAnterior = resposta.data.faturamentoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamentoAnterior = false })

        await Comercial.showDevolucaoMesAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolucaoAnterior = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDevolucaoAnterior = false })

        await Comercial4.showPesoFaturadoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorPesoFaturadoAnterior = resposta.data.kilos.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })

            this.valorPrecoMedioAnterior = resposta.data.precoMedio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => {
          this.loadingPesoFaturadoAnterior = false

          this.loadingPrecoMedioAnterior = false
        })

        await Comercial.showFaturamentoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamentoAnoAnterior = resposta.data.faturamentoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamentoAnoAnterior = resposta.data.faturamentoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamentoAnoAnterior = false })

        await Comercial.showDevolucaoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolucaoAnoAnterior = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDevolucaoAnoAnterior = false })

        await Comercial4.showPesoFaturadoAnoAnterior(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorPesoFaturadoAnoAnterior = resposta.data.kilos.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })

            this.valorPrecoMedioAnoAnterior = resposta.data.precoMedio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => {
          this.loadingPesoFaturadoAnoAnterior = false

          this.loadingPrecoMedioAnoAnterior = false
        })

        await Comercial.showTendenciaFaturamento(this.primeiroDia, this.date, this.select, this.supervisores, this.receitas, localStorage.tokencontrato, this.vendedor, this.rede, this.categoria, this.promotor, [], []).then(resposta => {
          if (resposta.data.status) {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não hsá tendência pro mês selecionado') {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingTendenciaFaturamento = false })

        await Comercial.showDiasFaturamento(this.primeiroDia, this.date, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.diasUteis = resposta.data.diaUtil.toString()
            this.diasPecorrido = resposta.data.diatrabalhados.toString()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDiasUteis = false })
      },

      async enableTexto (value) {
        await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value).then(resposta => {
          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao

            this.codigo = value
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.message === 'Permissão para a pagina não encontrada, metodo 8') {
            this.$router.push('/dashboard')
          }
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    .filterMobile{
      display: block
    }

    .filterWeb{
      display: none
    }

    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    .item {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    .break {
      flex-basis: 100%;
      height: 0;
    }

    #faturamentoComercial4 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 2rem 0 0 11rem;
    }

    #iconInformationFaturamentoComercial4 {
      margin: -6.5rem 0 0 22rem !important;
      font-size: 19px;
    }

    #valorFatFaturamentoComercial4 {
      margin: -5rem 0 0 -1.8rem;
    }

    #pesoFaturadoComercial4 {
      margin: 6rem 0 0 -26rem;
    }

    #textoDevolucaoComercial4 {
      margin: -9rem 0 0 -3.4rem;
      font-size: 12px;
    }

    #iconInformationDevolucaoComercial4 {
      margin: -18.5rem 0 0 -0.5rem;
    }

    #componenteVlrDevAtualComercial4 {
      margin: -12rem 0 0 -1rem;
    }

    #metaComercial4 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -9rem 0 0 -9.9rem !important;
    }

    #iconInformationMetaComercial4 {
      margin: -18.65rem 0 0 -1rem !important;
      font-size: 19px;
    }

    #valorMetaIdComercial4 {
      margin: -11rem 0 0 -1.5rem;
    }

    #textoMetaMensal {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 1rem 0 0 -3rem !important;
    }

    #BarLineComercial4 {
      height: 110px;
      width: 370px;
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      /* margin: -14rem 0 0 2rem !important; */
    }

    /* #iconInformationFatxMetaComercial4 {
      margin: -22rem 0 0 30.9rem !important;
    } */

    #dividerBloco1Comercial4 {
      margin: 3rem 0 0 0;
    }

    .containerBarrasLinhas {
      display: flex;
      flex-wrap: wrap;
    }

    .itemBarrasLinhasComercial4 {
      flex-grow: 1;
      flex-basis: 100%;
      min-width: 360px;
    }

    #faturamentoAnteriorComercial4 {
      font-size: 12px;
      margin: 0rem 0 0 -24.6rem !important;
      display: block ruby;
    }

    #iconInformationFatMesAnteriorComercial4 {
      margin: -6.6rem 0 0 14rem !important;
    }

    #vlrFatMesAnteriorComercial4 {
      margin: -5rem 0 0 -2.1rem;
    }

    #textoDevolucaoAnteriorComercial4 {
      margin: -8rem 0 0 5rem;
      font-size: 12px;
    }

    #iconInformationDevolucaoAnteriorComercial4 {
      margin: -19.5rem 0 0 31rem;
    }

    #componenteDevMesAnteriorComercial4 {
      margin: -13.8rem 0 0 13.5rem;
    }

    #linhaVerticalComercial4 {
      display: none;
    }

    #componenteDadosAnoAnteriorComercial4 {
      margin: 0rem 0 0 0rem;
    }

    #compFatMesAnoAnteriorComercial4 {
      margin: 0rem 0 0 0rem;
    }

    #faturamentoMesAnoAnteriorComercial4 {
      font-size: 12px;
      margin: 0 0 0 -37rem !important;
    }

    #iconInformationFatMesAnoAnteriorComercial4 {
      margin: -6.4rem 0 0 7.4rem !important;
    }

    #pesoFatAnoAnteriorIdComercial4 {
      margin: -7rem 0 0 17rem;
    }

    #valorFatMesAnoAnteriorIdComercial4 {
      margin: -35rem 0 0  0rem !important;
    }

    #textoDevolucaoAnoAnteriorComercial4 {
      margin: -8rem 0 0 4.3rem;
      font-weight: bold;
      font-size: 12px;
    }

    #iconInformationDevolucaoAnoAnteriorComercial4 {
      margin: -19.5rem 0 0 31rem;
    }

    #componenteDevAnoAnteriorComercial4 {
      margin: -13.8rem 0 0 13rem;
    }

    #componentePesoFaturadoAnoAnteriorComercial4 {
      margin: -1rem 0 0 -16rem;
    }

    .divider2 {
      margin: -8rem 0 0 0rem !important;
    }

    #btnRefazer {
      font-size: 10px;
      margin-top: 2rem;
      margin-left: -1.4rem;
    }

    #iniciobloco2Comercial4 {
      font-size: 12px;
      display: flex;
      align-items: center;
    }

    #iconInformationComercial4 {
      margin: 0 0 0 15.6rem !important;
    }

    #valorMonetarioComercial4 {
      font-size: 8px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: -2rem 0 10rem 0;
    }

    #valorMonetarioGraficoComercial4 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 15rem 0;
    }

    #valorMonetarioDiarioGraficoComercial4 {
      font-size: 12px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 0 0 15rem 0;
    }

    #tendenciaDiasIdComercial4 {
      margin: 3rem 0 0 1rem;
    }

    .textoTendenciaFaturametnoComercial4 {
      margin: 9rem 0 0 2rem;
    }

    .textoDiasFaturametnoComercial4 {
      margin: -2rem 0 0 2rem;
    }

    #iconInformationDiasUteisComercial4 {
      margin: 0 0 0 8.9rem !important;
    }

    #iconInformationTendenciaComercial4 {
      margin: -1.7rem 0 0 28.8rem !important;
    }

    #textoCarteiraPedidoComercial4 {
      margin: -15rem 0 0 2.5rem !important;
    }

    #iconInformationPedidosComercial4 {
      margin: -15rem 0 0 16.4rem !important;
    }

    #carteiraPedidoIdComercial4 {
      margin: -10rem 0 0 0rem
    }

    #componenteVolumeId {
      margin: 18rem 0 0 0;
    }

    #componentePesoFatAnterior {
      margin: 0rem 0 0 0rem
    }

    #componentePesoFaturadoAnoAnterior {
      margin: 0 0 0 0rem
    }

    #valorMonetarioIdComercial4 {
      margin: 5rem 0 0 0
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #faturamentoComercial4 {
      margin: 4rem 0 0 -14rem;
    }

    #iconInformationFaturamentoComercial4 {
      margin: 4.2rem 0 0 -15rem;
    }

    #valorFatFaturamentoComercial4 {
      margin: -2rem 0 0 -3rem;
    }

    #pesoFaturadoComercial4 {
      margin: 0 0 0 3rem;
    }

    #textoDevolucaoComercial4 {
      margin: -2rem 0 0 -3.7rem;
    }

    #iconInformationDevolucaoComercial4 {
      margin: -4rem 0 0 2.4rem;
    }

    #componenteVlrDevAtualComercial4 {
      margin: -3rem 0 0 -7.4rem;
    }

    #metaComercial4 {
      margin: -2rem 0 0 -10rem;
    }

    #iconInformationMetaComercial4 {
      margin: -4rem 0 0 -1.7rem;
    }

    #valorMetaIdComercial4 {
      margin: -2.85rem 0 0 2rem;
    }

    #iconInformationFatxMetaComercial4 {
      margin: -1rem 0 0 -1.5rem;
    }

    #faturamentoAnteriorIdComercial4 {
      margin: -1.75rem 0 0 -1.4rem !important;
    }

    #faturamentoAnteriorComercial4 {
      margin: 1rem 0 0 0.2rem !important;
    }

    #iconInformationFatMesAnteriorComercial4 {
      margin: 1.2rem 0 0 3.8rem !important;
    }

    #vlrFatMesAnteriorComercial4 {
      margin: -45.5rem 0 0 17.5rem;
    }

    #textoDevolucaoAnteriorIdComercial4 {
      margin: -2.2rem 0 0 -1.8rem;
    }

    #textoDevolucaoAnteriorComercial4 {
      display: grid;
      align-items: center;
      margin: 1.4rem 0 0 -0.9rem;
      font-weight: bold;
    }

    #iconInformationDevolucaoAnteriorComercial4 {
      margin: 1.5rem 0 0 1.8rem;
    }

    #componenteDevMesAnteriorComercial4 {
      margin: -1.3rem 0 0 3.8rem;
    }

    #componentePesoAnteriorComercial4 {
      margin: -1rem 0 0 -6rem;
    }

    #linhaVerticalComercial4 {
      display: none;
    }

    #componenteDadosAnoAnteriorComercial4 {
      margin: -3rem 0 0 0rem;
    }

    #compFatMesAnoAnteriorComercial4 {
      margin: -1.8rem 0 0 3.3rem;
    }

    #faturamentoMesAnoAnteriorComercial4 {
      margin: 1rem 0 0 -9rem;
    }

    #iconInformationFatMesAnoAnteriorComercial4 {
      margin: 1.1rem 0 0 -0.85rem !important;
    }

    #valorFatMesAnoAnteriorIdComercial4 {
      margin: -46rem 0 0 17rem !important;
    }

    #textoDevolucaoAnoAnteriorComercial4 {
      margin: -7.45rem 0 0 38rem;
    }

    #iconInformationDevolucaoAnoAnteriorComercial4 {
      margin: -15rem 0 0 30.6rem;
    }

    #componenteDevAnoAnteriorComercial4 {
      margin: -9.75rem 0 0 44rem;
    }

    #pesoFatAnoAnteriorIdComercial4 {
      margin: -4rem 0 0 8.8rem;
    }

    #iconInformationComercial4 {
      margin: 0rem 0 0 40rem !important;
    }

    #iconInformationTendenciaComercial4 {
      margin: -1.5rem 0 0 58rem !important;
    }

    #iconInformationDiasUteisComercial4 {
      margin: -2rem 0 0 38rem !important;
    }

    #vlrValorDiasUteisComercial4 {
      margin: 0 0 0 17rem;
    }

    #iconInformationPedidosComercial4 {
      margin: -0.5rem 0 0 39.3rem !important
    }

    #carteiraPedidoIdComercial4 {
      margin: 0 0 0 -12rem
    }

    #iconInformationVolumetria {
      margin: 0 0 0 21rem !important;
    }

    .textoDiasFaturametnoComercial4 {
      margin: auto;
    }

    .textoTendenciaFaturametnoComercial4 {
      margin: auto
    }

    #componenteCarteiraPedidosComercial4 {
      margin: 0 0 0 3rem;
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px) {
    #faturamentoComercial4 {
      margin: 4rem 0 0 2rem;
    }

    #iconInformationFaturamentoComercial4 {
      margin: 4.2rem 0 0 -15rem;
    }

    #valorFatFaturamentoComercial4 {
      margin: -2rem 0 0 -3rem;
    }

    #pesoFaturadoComercial4 {
      margin: 0 0 0 3rem;
    }

    #textoDevolucaoComercial4 {
      margin: -2rem 0 0 -3.7rem;
    }

    #iconInformationDevolucaoComercial4 {
      margin: -4rem 0 0 2.4rem;
    }

    #componenteVlrDevAtualComercial4 {
      margin: -3rem 0 0 -7.4rem;
    }

    #metaComercial4 {
      margin: -2rem 0 0 -10rem;
    }

    #iconInformationMetaComercial4 {
      margin: -4rem 0 0 -1.7rem;
    }

    #valorMetaIdComercial4 {
      margin: -2.85rem 0 0 2rem;
    }

    #iconInformationFatxMetaComercial4 {
      margin: -2rem 0 0 0.7rem;
    }

    #faturamentoAnteriorComercial4 {
      margin: 1rem 0 0 0.2rem !important;
    }

    #iconInformationFatMesAnteriorComercial4 {
      margin: 1.2rem 0 0 3.8rem !important;
    }

    #vlrFatMesAnteriorComercial4 {
      margin: -1.15rem 0 0 4.5rem;
    }

    #textoDevolucaoAnteriorComercial4 {
      display: grid;
      align-items: center;
      margin: 1.4rem 0 0 -0.9rem;
      font-weight: bold;
    }

    #iconInformationDevolucaoAnteriorComercial4 {
      margin: 1.5rem 0 0 1.5rem;
    }

    #componenteDevMesAnteriorComercial4 {
      margin: -1.3rem 0 0 3.8rem;
    }

    #componentePesoAnteriorComercial4 {
      margin: -1rem 0 0 -6rem;
    }

    #linhaVerticalComercial4 {
      margin: -1.2rem 0 0 6rem;
    }

    #componenteDadosAnoAnteriorComercial4 {
      margin: 0 0 0 -12rem;
    }

    #compFatMesAnoAnteriorComercial4 {
      margin: -0.8rem 0 0 -5rem;
    }

    #faturamentoMesAnoAnteriorComercial4 {
      margin: 1rem 0 0 -9rem;
    }

    #iconInformationFatMesAnoAnteriorComercial4 {
      margin: 1.1rem 0 0 -1.85rem !important;
    }

    #valorFatMesAnoAnteriorIdComercial4 {
      margin: -2rem 0 0 0rem !important;
    }

    #textoDevolucaoAnoAnteriorComercial4 {
      margin: -0.8rem 0 0 -10rem;
    }

    #iconInformationDevolucaoAnoAnteriorComercial4 {
      margin: -1.7rem 0 0 8.3rem;
    }

    #componenteDevAnoAnteriorComercial4 {
      margin: -1.75rem 0 0 9rem;
    }

    #pesoFatAnoAnteriorIdComercial4 {
      margin: 0rem 0 0 -1.2rem;
    }

    #iconInformationTendenciaComercial4 {
      margin: -1.5rem 0 0 30rem !important;
    }

    #iconInformationDiasUteisComercial4 {
      margin: -3rem 0 0 30rem !important;
    }

    #iconInformationPedidosComercial4 {
      margin: -1.5rem 0 0 33rem !important
    }

    #iconInformationVolumetria {
      margin: 0 0 0 21rem !important;
    }

    #componentePesoFatAnterior {
      margin: 0 0 0 0 !important
    }

    #componentePesoFaturadoAnoAnterior {
      margin: 0 0 0 -5rem !important
    }
  }

  @media screen
  and (min-width: 1601px) {
    #faturamentoComercial4 {
      margin: 4rem 0 0 2rem;
    }

    #iconInformationFaturamentoComercial4 {
      margin: 4.2rem 0 0 -15rem;
    }

    #valorFatFaturamentoComercial4 {
      margin: -1rem 0 0 -4rem;
    }

    #textoDevolucaoComercial4 {
      margin: 0rem 0 0 4.3rem;
    }

    #iconInformationDevolucaoComercial4 {
      margin: 0.2rem 0 0 4.4rem;
    }

    #componenteVlrDevAtualComercial4 {
      margin: -1rem 0 0 0.6rem;
    }

    #metaComercial4 {
      margin: 0rem 0 0 -8rem;
    }

    #iconInformationMetaComercial4 {
      margin: 0.25rem 0 0 0.3rem;
    }

    #valorMetaIdComercial4 {
      margin: -0.85rem 0 0 -5rem;
    }

    #iconInformationFatxMetaComercial4 {
      margin: -2rem 0 0 0.7rem;
    }

    #blocoMesAnteriorIdComercial4 {
      margin: 0 0 0 2rem;
    }

    #faturamentoAnteriorIdComercial4 {
      margin: -1.75rem 0 0 -2rem !important;
    }

    #faturamentoAnteriorComercial4 {
      margin: 1.4rem 0 0 4.2rem !important;
    }

    #iconInformationFatMesAnteriorComercial4 {
      margin: 1.5rem 0 0 3.8rem !important;
    }

    #vlrFatMesAnteriorComercial4 {
      margin: -0.8rem 0 0 7rem;
    }

    #textoDevolucaoAnteriorIdComercial4 {
      margin: -1.7rem 0 0 0rem;
    }

    #textoDevolucaoAnteriorComercial4 {
      display: grid;
      align-items: center;
      margin: 1.4rem 0 0 -0.9rem;
      font-weight: bold;
    }

    #iconInformationDevolucaoAnteriorComercial4 {
      margin: 1.5rem 0 0 2.5rem;
    }

    #componenteDevMesAnteriorComercial4 {
      margin: -1rem 0 0 5.3rem;
    }

    #componentePesoAnteriorComercial4 {
      margin: 0rem 0 0 -2rem;
    }

    #linhaVerticalComercial4 {
      margin: -1.2rem 0 0 6rem;
    }

    #componenteDadosAnoAnteriorComercial4 {
      margin: 0 0 0 -14rem;
    }

    #compFatMesAnoAnteriorComercial4 {
      margin: -0.8rem 0 0 -3rem;
    }

    #faturamentoMesAnoAnteriorComercial4 {
      margin: 1.4rem 0 0 -8rem;
    }

    #iconInformationFatMesAnoAnteriorComercial4 {
      margin: 1.5rem 0 0 0rem !important;
    }

    #valorFatMesAnoAnteriorIdComercial4 {
      margin: -1.7rem 0 0 0rem !important;
    }

    #textoDevolucaoAnoAnteriorComercial4 {
      margin: -0.5rem 0 0 -12rem;
    }

    #iconInformationDevolucaoAnoAnteriorComercial4 {
      margin: -0.9rem 0 0 7.9rem;
    }

    #componenteDevAnoAnteriorComercial4 {
      margin: -1rem 0 0 0rem;
    }

    #pesoFatAnoAnteriorIdComercial4 {
      margin: 1.55rem 0 0 -2.25rem;
    }

    #iconInformationComercial4 {
      margin: 0rem 0 0 21rem !important;
    }

    #iconInformationTendenciaComercial4 {
      margin: -1.5rem 0 0 36rem !important;
    }

    #iconInformationDiasUteisComercial4 {
      margin: -3rem 0 0 36rem !important;
    }

    #iconInformationPedidosComercial4 {
      margin: -1.5rem 0 0 39rem !important
    }

    #iconInformationVolumetria {
      margin: 0 0 0 21rem !important;
    }
  }
</style>

<style lang="sass">
  .filterMobile
    display: none

  .filterWeb
    display: block

  #faturamentoComercial4
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem auto
    font-weight: bold

  #iconInformationFaturamentoComercial4
    margin: 0.8rem 0 0 -9rem

  #valorFatFaturamentoComercial4
    margin: -2rem 0 0 -2rem

  #pesoFaturadoComercial4
    margin: -2rem 0 0 2rem

  #iconInformationDevolucaoComercial4
    margin: -3.9rem 0 0 2.21rem

  #componenteVlrDevAtualComercial4
    margin: -2rem 0 0 2rem

  #metaComercial4
    font-size: 16px
    display: grid
    align-items: center
    margin: -2rem 0 0 -7rem
    font-weight: bold

  #iconInformationMetaComercial4
    margin: -4.5rem 0 0 0.5rem

  #valorMetaIdComercial4
    margin: -2rem 0 0 -1rem
    position: relative

  #textoMetaMensal
    font-size: 16px
    display: grid
    align-items: center
    font-weight: bold
    margin: 0 0 -2rem 0

  #iconInformationFatxMetaComercial4
    margin: 1rem 0 0 1.5rem

  #faturamentoAnteriorIdComercial4
    margin: auto

  #faturamentoAnteriorComercial4
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 1rem
    font-weight: bold

  #iconInformationFatMesAnteriorComercial4
    margin: 0.8rem 0 0 2.2rem !important

  #vlrFatMesAnteriorComercial4
    margin: -1rem 0 0 0.3rem

  #faturamentoMesAnoAnteriorComercial4
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.7rem 0 0 -7rem
    font-weight: bold

  #iconInformationFatMesAnoAnteriorComercial4
    margin: 1rem 0 0 0.2rem !important

  #valorFatMesAnoAnteriorIdComercial4
    margin: -2rem 0 0 -1rem

  #linhaVerticalComercial4
    margin: -1.4rem 0 0 5rem

  #btnRefazer
    margin: 1.5rem auto

  #iconInformationComercial4
    margin: 0 0 0 8.5rem !important
    display: block

  #iconInformationTendenciaComercial4
    margin: -1.5rem 0 0 25rem !important
    display: block

  #iconInformationPedidosComercial4
    margin: 0 0 0 8.5rem !important
    display: block

  #iconInformationVolumetria
    margin: 0 0 0 8.5rem
    display: block

  #iniciobloco2Comercial4
    margin-left: 2rem

  #textoCarteiraPedidoComercial4
    margin-right: 5rem

  #volumetriaTexto
    margin-right: 3.4rem

  #textoDiasFaturametnoComercial4
    margin-top: 1.4rem

  #iconInformationDiasUteisComercial4
    margin: 0 0 0 5.2rem !important

  #textoDevolucaoComercial4
    font-size: 16px
    display: grid
    align-items: center
    margin: -2rem auto
    font-weight: bold

  #textoDevolucaoAnteriorComercial4
    font-size: 16px
    display: grid
    align-items: center
    margin: 0.8rem 0 0 -4rem
    font-weight: bold

  #iconInformationDevolucaoAnteriorComercial4
    margin: 1.1rem 0 0 0.6rem

  #componenteDevMesAnteriorComercial4
    margin: -1.3rem 0 0 1.2rem

  #componentePesoAnteriorComercial4
    margin: 0 0 0 4.5rem

  #componenteDadosAnoAnteriorComercial4
    margin: 0 0 0 -10rem

  #textoDevolucaoAnoAnteriorComercial4
    font-size: 16px
    font-weight: bold
    margin: 1rem 0 0 0rem

  #iconInformationDevolucaoAnoAnteriorComercial4
    margin: 1rem 0 0 3rem

  #componenteDevAnoAnteriorComercial4
    margin: -1.5rem 0 0 0rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFatxMeta
    // padding-right: 57rem !important
    margin: -2rem 0 0 -1rem

  #componentePesoFatAnterior
    margin: 0rem 0 0 -2rem

  #componenteDevoluaAnoAnterior
    margin: -2rem 0 0 0rem

  #componentePesoFaturadoAnoAnterior
    margin: 0rem 0 0 -3rem

  #valorMonetarioIdComercial4
    margin: -2rem 0 0 0

  #listItemValorMonetario
    // padding-right: 0rem !important
    margin: -2rem 0 0 -1rem

  #componenteTendenciaFaturamento
    margin: -2rem 0 0 0

  #componenteCarteiraPedidosComercial4
    margin: -2rem 0 0 0rem

  #componentePedidos
    margin: -3rem 0 0 6rem

  // #textoTotalAberto
  //   margin: 1rem 0 0 5rem !important

  // #carteiraPedidosAberto
    // font-size: 16px
    // display: grid
    // align-items: center
    // font-weight: bold
    // margin: 0rem 0 0 6rem

  // #idIconSearchAberto
    // margin: 0 0 0 -10rem

  // #textoTotalMes
  //   margin: 1rem 0 0 5rem !important

  // #carteiraPedidosMes
  //   font-size: 16px
    // display: grid
    // align-items: center
    // font-weight: bold
    // margin: 0rem 0 0 2.3rem

  // #idIconSearchMes
    // margin: 0 0 0 -13.5rem

  // #textoTotalDia
  //   margin: 1rem 0 0 5rem !important

  // #carteiraPedidosDia
    // font-size: 16px
    // display: grid
    // align-items: center
    // font-weight: bold
    // margin: 0rem 0 0 1rem

  // #idIconSearchDia
    // margin: 0rem 0 0 -12rem

</style>
